(function($) {
    var self = {};
    var pageIndex = 1;
    var loadMoreButton = $('._jsLoadMore');
    var blogListContainer = $('._jsBlogArticleList');
    var totalNumberOfArticles;

    self.init = function () {

        if (blogListContainer.length == 0) {
            return;
        }

        totalNumberOfArticles = parseInt(blogListContainer.data('totalnumber'));
        self.toggleButton();

        loadMoreButton.on('click', function () {
            $.ajax({
                url: window.location.pathname + '/LoadMore?page=' + pageIndex + '&tag=svada',
                dataType: 'html'
            }).done(function (data) {
                blogListContainer.append(data);
                pageIndex++;
                self.toggleButton();
            });
        });

    };

    self.toggleButton = function () {
        if (totalNumberOfArticles <= blogListContainer.children().length) {
            loadMoreButton.hide();
        } else {
            loadMoreButton.show();
        }
        return;
    };

    self.init();

}(jQuery));